import(/* webpackMode: "eager", webpackExports: ["ResetPasswordForm"] */ "/vercel/path0/src/components/auth/reset-password-form.tsx");
